<template>
  <tr>
    <th class="c-text--en c-text--center">
      {{ item.createdAt | dateText('YYYY.MM.DD') }}
    </th>
    <td
      :class="{ alert: isEdited.keyword && error.keyword, editLine: isActive }"
    >
      <div class="l-row l-no-gutters">
        <div class="l-col">
          <div class="c-alertPos">
            <Input
              class="c-text--ellipsis"
              v-model="temp.keyword"
              :placeholder="params.keyword"
              :disabled="isLoading || !isActive"
              ref="focus"
              @focusout="focusout"
            />
            <Alert v-if="isEdited.keyword && error.keyword">
              {{ error.keyword }}
            </Alert>
          </div>
        </div>
        <div class="l-col l-col-auto">
          <Button
            v-if="isActive"
            variant="main"
            size="w180"
            fsize="f16"
            :disabled="isLoading || !temp.keyword || isError || isProcessing"
            :class="{ 'is-loading': isProcessing }"
            @click="edit"
          >
            変更確定する
          </Button>
          <Button class="edit" @click="toggle">
            編集する
          </Button>
        </div>
      </div>
    </td>
    <td class="c-text--center">
      <div class="c-alertPos">
        <Alert v-if="error.delete">{{ error.delete }}</Alert>
        <Button
          v-if="!isActive"
          radius
          variant="delete"
          :disabled="isLoading || isProcessing"
          @click="remove"
        >
          <Tooltip v-if="!isProcessing && !error.delete" variant="btn">
            キーワードを削除
          </Tooltip>
        </Button>
      </div>
    </td>
  </tr>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Tooltip from '@/components/Tooltip';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Input,
    Tooltip
  },

  data() {
    return {
      error: {
        delete: '',
        keyword: ''
      },
      params: {
        keyword: this.item.keyword
      },
      temp: {
        keyword: this.item.keyword
      },
      timeoutId: null,
      isActive: false,
      isEdited: {
        keyword: false
      },
      isError: false,
      isProcessing: false
    };
  },

  computed: {
    keywordNames() {
      let keywords = this.items.map(item => item.keyword);
      keywords.splice(this.index, 1);
      return keywords;
    }
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    keywordNames: {
      handler() {
        this.validate();
      }
    },
    'temp.keyword': {
      handler() {
        this.validate();
      },
      immediate: true
    }
  },

  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },

    edit() {
      if (this.isError || this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      apiProjects.nominatedKeywords
        .delete(this.item.id, this.auth.idToken, this.project.id)
        .then(response => {
          let params = {
            keyword: this.temp.keyword
          };
          apiProjects.nominatedKeywords
            .post(params, this.auth.idToken, this.project.id)
            .then(response => {
              this.params.keyword = this.temp.keyword;
              this.isActive = false;
              this.isProcessing = false;
              this.$emit('edit');
            })
            .catch(error => {
              if (error.response) {
                this.error.keyword = error.response.data.errors[0].userMessage;
              }
              this.isProcessing = false;
            });
        })
        .catch(error => {
          if (error.response) {
            this.error.keyword = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    },

    focusout() {
      this.temp.keyword = this.$options.filters.replaceDoubleSpaceToSpace(
        this.temp.keyword
      );
    },

    remove() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      apiProjects.nominatedKeywords
        .delete(this.item.id, this.auth.idToken, this.project.id)
        .then(response => {
          this.isProcessing = false;
          this.$emit('delete', this.index);
        })
        .catch(error => {
          if (error.response) {
            this.error.delete = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;

          // 削除失敗時のエラーメッセージを消すのに丁度いいトリガーがないので、3秒後に消すようにする
          this.timeoutId = setTimeout(() => {
            this.error.delete = '';
          }, 3000);
        });
    },

    toggle() {
      this.isActive = !this.isActive;

      if (this.isActive) {
        this.temp.keyword = '';
        this.$nextTick(() => {
          this.$refs.focus.$el.focus();
        });
      } else {
        this.temp.keyword = this.params.keyword;
      }
    },

    validate() {
      let keyword = this.$options.filters.replaceDoubleSpaceToSpace(
        this.temp.keyword.trim()
      );
      this.error.keyword = new Validation()
        .input()
        .notRegistered(this.keywordNames, 'すでに登録されているキーワードです')
        .test(keyword);
      this.isEdited.keyword = keyword ? true : false;
    }
  }
};
</script>
